define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    url: '/delegate/civics-api/api/portal/users/forgotusername',
    sync: function(method, model, options) {
      var recaptchaToken = model.get('g-recaptcha-response');
      if(recaptchaToken != null)
      {
        options.beforeSend = function(xhr) {
          xhr.setRequestHeader('X-reCaptcha-Response', recaptchaToken);
        };

        model.set('g-recaptcha-response', null);
      }

      return Backbone.sync(method, model, options);
    }
  });
});
